export default {
    diagramPlugins: [],
    parallelHTCheckbox: false,
    selectedPluginCode: null,
    selectedPluginUuid: null,
    copyOfInitialContentDiagram: [],
    copyOfInitialConnectorsDiagram: [],
    copyOfInitialMessagesDiagam: [],
    diagramData: {
        connectors: [],
        content: []
    },
    diagramConfigData: {
        content: [],
        connectors: [],
        messages: []
    },
    configCache: {
        content: {},
        connectors: {}
    },
    selectedPluginData: [],
    guiForProcessDefinition: [],
    modelForProcessDefinition: {},
    setModelForProcessDefinition: [],
    variables: {
        modelVariables: []
    },
    processWithError: {},
    setAllAppi: [],
    isFromResponse: false,
    setAllRequest: [],
    setAllResponse: [],
    setAllRequestCallApi: [],
    setAllResponseCallApi: [],
    setAllErrors: [],
    apiParam: "",
    tatData: null,
    hasNewComments: false,
    activeProcesses: {},
    activeProcessesCount: 0,
    externalStartUrl: "",
    scDetailsFunction: [],
    scDetailsEvent: [],
    exposeStartUrl: "",
    activities: {},
    auditTrails: [],
    externalTaskRegularMessages: [],
    externalTaskDynamicMessages: [],
    auditTrail: [],
    documentsList: [],
    lastPluginCreated: {},
    externalDraftDataSMS: {
        smsBoby: ""
    },
    externalDraftDataEmail: {
        attachments: [],
        bodyEmail: "",
        subject: ""
    },
    externalDraftDataEmailAuth: {
        attachments: [],
        subject: "",
        body: ""
    },
    diagramStateModifications: [],
    externalMapReqData: {
        dataModelFields: [],
        rules: []
    },
    connectorsValidation: [],
    warningOnApp: [], // warnings list on publish application
    componentsConfig: {
        label: {
            propName: "label",
            propType: "content",
            name: "setLabel",
            category: "details"
        },
        code: {
            propName: "code",
            propType: "content",
            name: "setCode",
            category: "details"
        },
        recurrence: {
            propName: "recurrence",
            propType: "content",
            name: "setRecurrence",
            category: "details"
        },
        taskSubject: {
            propName: "taskSubject",
            propType: "content",
            name: "setTaskSubject",
            category: "details"
        },
        instanceName: {
            propName: "instanceName",
            propType: "content",
            name: "setInstanceName",
            category: "details"
        },
        description: {
            propName: "description",
            propType: "content",
            name: "setDescription",
            category: "details"
        },
        deadline: {
            propName: "deadline",
            propType: "content",
            name: "setDeadline",
            category: "details"
        },
        expiration: {
            propName: "expiration",
            propType: "content",
            name: "setExpiration",
            category: "details"
        },
        taskPriority: {
            propName: "taskPriority",
            propType: "content",
            name: "setTaskPriority",
            category: "details"
        },
        gui: {
            propName: "guiId",
            propType: "content",
            name: "setGui",
            category: "details"
        },
        rules: {
            propName: "rules",
            propType: "content",
            name: "setRules",
            category: "rules"
        },
        users: {
            propName: "users",
            propType: "content",
            name: "setUsers",
            category: "users"
        },
        multiple: {
            propName: "multiple",
            propType: "content",
            name: "multiple",
            category: "users"
        },
        target: {
            propName: "targets",
            propType: "content",
            name: "setTarget",
            category: "targets"
        },
        levels: {
            propName: "levels",
            propType: "content",
            name: "setLevels",
            category: "levels"
        },
        dynamicExternalTask: {
            propName: "dynamicExternalTask",
            propType: "content",
            name: "setDynamicTask",
            category: "details"
        },
        smsSubject: {
            propName: "smsSubject",
            propType: "content",
            name: "setSMS",
            category: "details"
        },
        emailSubject: {
            propName: "emailSubject",
            propType: "content",
            name: "setEmail",
            category: "details"
        },
        messagingOptions: {
            propName: "messagingOptions",
            propType: "content",
            name: "setMessagingOptions",
            category: "details"
        },
        configDocuments: {
            propName: "documents",
            propType: "content",
            name: "setDocumentsToGenerate",
            category: "details"
        },
        status: {
            propName: "status",
            propType: "content",
            name: "setStatus",
            category: "details"
        },
        exclusiveGatewayRoutes: {
            propName: "exclusiveGatewayRoutes",
            propType: "content",
            name: "setExclusiveGateway",
            category: "details"
        },
        approvalEvent: {
            propName: "approvalEvent",
            propType: "content",
            name: "setApprovalEvent",
            category: "details"
        },
        blockchainFunction: {
            propName: "blockchainFunction",
            propType: "content",
            name: "setBlockchainFunction",
            category: "details"
        },
        blockchainEvent: {
            propName: "blockchainEvent",
            propType: "content",
            name: "setBlockchainEvent",
            category: "details"
        },
        setProcess: {
            propName: "setProcess",
            propType: "content",
            name: "setProcess",
            category: "details"
        },
        configureAdvancedLogic: {
            propName: "advancedLogicScript",
            propType: "content",
            name: "setConfigureAdvancedLogic",
            category: "details"
        }
    },
    allTimelineTaskDetails: [], // all tasks details - timeline
    allTimelineAppLevelDetails: [], // all approval matrix level task details
    diagramFileNameWithDataModel: null
};
